import * as d3 from 'd3'

export default {
  methods: {
    
    event_Link(selection, data_, col, color_) {
      
      if (col.filter == '') return
      
      selection
      .on('mouseover', function() {
        d3.select(this).transition().duration(100).attr('fill', '#EC407A')
      })
      .on('mouseout', function() {
        d3.select(this).transition().duration(300).attr('fill', color_)
      })
      .on('click', () => { 
        let dataSource = {}
        Object.keys(this.keys).forEach(d=>{
          dataSource = {...dataSource, [d]: data_[this.keys[d]]}
        })
 
        // ********************************************************************************
        console.log('dataSource: ', dataSource)
        let filterTesting = col.filter !== '' ? this.filters[col.filter] : ''
        console.log('filterString_: ', filterTesting)
        // ********************************************************************************

        
        // Mapping the jsonLink(value) to JsonProps in A/G 
        let request_ = this.getRequestColumnProps('request', dataSource, this.ColumnProps)
        if(!request_) return

        // set for filterString 
        let filterString_ = col.filter !== '' ? this.filters[col.filter] : ''
        

        // if A/G filterString is exist, set request_.iFilters.filterString + filterString_
        if(request_.iFilters.filterString) {
          request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
        } else {
          request_.iFilters.filterString = filterString_||''
        }

        // combine filterString and inputFilter &&& emit request-action
        request_ = {...request_,
          filters : {
            ...this.FilterValues,
            ...request_.filters,
          },
          iFilters: { 
            filterString : request_.iFilters.filterString||'',
            inputFilter : request_.iFilters.inputFilter,},
        }
        this.$emit('request-action', request_)
      })
    }, 


 
    
  }
}